import script from "./BankbookMatchDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankbookMatchDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__